import React, { useState,useEffect, useMemo } from 'react';
import { compose } from 'redux';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { change, Field, reduxForm } from 'redux-form';
import { useHistory } from 'react-router-dom';

import {
    createPaymentGatewayCredentialStepRequest,
    resetPaymentGatewayCredentialCreateFormData,
    resetPaymentGatewayCredentialUpdateFormData,
    updatePaymentGatewayCredentialStepRequest,
    fetchPaymentGatewayCredentialDataRequest
} from '../redux/paymentGatewayCredentials.actions';

import { fetchPaymentModesRequest } from 'containers/MerchantOnboard/redux/merchantOnBoard.actions';

import { pgCredentialsPayModeFormValidator } from './validator';
import { connect } from 'react-redux';
import { capitalize, isEmpty } from 'lodash';
import { capitalizeStringWithUnderscores } from 'utils/helperMethods';
import { Alert, FormElems } from 'components';
import { getPGCredentialPayModeRequestFromValues } from '../constants';

const getOptions = ({ data, labelField, valueField, isStringArray }) => {
    if (isStringArray) {
        return data.map(item => {
            return {
                name: capitalize(item),
                value: item,
            };
        });
    }
    return data.map(item => {
        return {
            ...item,
            name: item[labelField],
            value: item[valueField],
        };
    });
};

const getPayOptions = (paymentModes, payValues) => {
    const formatValues = {
        DEBIT_CARD_OPTIONS: [],
        DEBIT_CARD_BUSINESS_SOURCE_OPTIONS: [],
        CREDIT_CARD_OPTIONS: [],
        CREDIT_CARD_BUSINESS_SOURCE_OPTIONS: [],
        UPI_OPTIONS: [],
        UPI_MANDATE_OPTIONS: [],
        UPI_BUSINESS_SOURCE: [],
        UPI_ACCOUNT_TYPES: [],
        NET_BANKING_OPTIONS: [],
        WALLET_OPTIONS: [],
    };
    if (paymentModes) {
        const {
            debitCards,
            debitCardBusinessSource,
            creditCards,
            creditCardBusinessSource,
            // upi,
            netbanking,
            upiAccountType,
            upiBusinessSource,
            wallets,
        } = paymentModes;
        if (debitCards && !isEmpty(debitCards)) {
            formatValues.DEBIT_CARD_OPTIONS = getOptions({
                data: debitCards,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (debitCardBusinessSource && !isEmpty(debitCardBusinessSource)) {
            formatValues.DEBIT_CARD_BUSINESS_SOURCE_OPTIONS = getOptions({
                data: debitCardBusinessSource,
                isStringArray: true,
            });
        }
        if (creditCards && !isEmpty(creditCards)) {
            formatValues.CREDIT_CARD_OPTIONS = getOptions({
                data: creditCards,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (creditCardBusinessSource && !isEmpty(creditCardBusinessSource)) {
            formatValues.CREDIT_CARD_BUSINESS_SOURCE_OPTIONS = getOptions({
                data: creditCardBusinessSource,
                isStringArray: true,
            });
        }
        if (upiAccountType && !isEmpty(upiAccountType)) {
            const resultObj = {};
            for (const [businessSource, accountTypes] of Object.entries(
                upiAccountType
            )) {
                const formattedAccountTypes = accountTypes.map(type => ({
                    accountTypesNameUI: capitalizeStringWithUnderscores(type),
                    accountTypesValue: type,
                }));
                resultObj[businessSource] = formattedAccountTypes;
            }
            formatValues.UPI_ACCOUNT_TYPES = !isEmpty(resultObj)
                ? resultObj
                : [];
        }
        // if (upi && !isEmpty(upi)) {
        //     formatValues.UPI_OPTIONS = getOptions({
        //         data: upi,
        //         labelField: 'subModeNameUI',
        //         valueField: 'subMode',
        //     });
        //     formatValues.UPI_MANDATE_OPTIONS = getOptions({
        //         data: upi,
        //         labelField: 'subModeNameUI',
        //         valueField: 'subMode',
        //     });
        // }
        // if (upiBusinessSource && !isEmpty(upiBusinessSource)) {
        //     formatValues.UPI_BUSINESS_SOURCE = getOptions({
        //         data: upiBusinessSource,
        //         isStringArray: true,
        //     });
        // }
        if (netbanking && !isEmpty(netbanking)) {
            formatValues.NET_BANKING_OPTIONS = getOptions({
                data: netbanking,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (wallets && !isEmpty(wallets)) {
            formatValues.WALLET_OPTIONS = getOptions({
                data: wallets,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
    }
    return formatValues;
};

const PGCredentialsModeForm = ({
    handleSubmit,
    merchantData,
    staticData,
    actions,
    isViewMode,
    formData,
    paymentGatewayCredentialsData,
    previousPath,
    nextPath,
    sectionType,
    formIdentifier,
    isEditMode,
    change,
}) => {
    const history = useHistory();
    console.log('okok creds paymode',
        formData,
        paymentGatewayCredentialsData,
);

    const { paymentModes } = merchantData;
    const { payValues } = staticData;
    const { createFormData, editFormData } = paymentGatewayCredentialsData;
    const [selectAllNetBanking, setSelectAllNetBanking] = useState(false); // state to track "Select All" checkbox for Net Banking

    const errorMessage =
        createFormData &&
        createFormData.error &&
        createFormData.error.errorMessage;

    const memoizedPay = useMemo(() => getPayOptions(paymentModes, payValues), [
        paymentModes,
        payValues,
    ]);

    const {
        DEBIT_CARD_OPTIONS,
        DEBIT_CARD_BUSINESS_SOURCE_OPTIONS,
        CREDIT_CARD_OPTIONS,
        CREDIT_CARD_BUSINESS_SOURCE_OPTIONS,
        UPI_OPTIONS,
        UPI_MANDATE_OPTIONS,
        UPI_BUSINESS_SOURCE,
        UPI_ACCOUNT_TYPES,
        NET_BANKING_OPTIONS,
        WALLET_OPTIONS,
    } = memoizedPay;

    useEffect(() => {
        if (
            createFormData.isSuccess &&
            createFormData.sectionType === sectionType
        ) {
            toast.success('PG Credential request created successfully');
            onNext();
        }
        return () => {
            if (
                createFormData.isSuccess &&
                createFormData.sectionType === sectionType
            ) {
                resetErrors();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createFormData.isSuccess, createFormData.sectionType]);

    useEffect(() => {
        // console.log("editFormData", editFormData)
        if (
            editFormData.isSuccess &&
            editFormData.sectionType === sectionType
        ) {
            if(!isViewMode){
                toast.success('PG Credential request updated successfully ');
            }
            onNext();
        }
        return () => {
            if (
                editFormData.isSuccess &&
                editFormData.sectionType === sectionType
            ) {
                actions.resetPaymentGatewayCredentialUpdateFormData();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editFormData.isSuccess, editFormData.sectionType]);

    const onNext = () => {
        if(!isEditMode){
            resetErrors();
        }
        history.push(nextPath);
    };

    const resetErrors = () => {
        actions.resetPaymentGatewayCredentialCreateFormData();
    };

    const onBack = () => {
        history.push(previousPath);
    };

    const handleFormSubmit = values => {
        if (!values.debitCard &&!values.creditCard &&!values.netbanking &&!values.wallets) {
            toast.error('Payment mode details should not be empty');
            return;
        }
        const request = getPGCredentialPayModeRequestFromValues({
            values,
            DEBIT_CARD_OPTIONS,
            DEBIT_CARD_BUSINESS_SOURCE_OPTIONS,
            CREDIT_CARD_OPTIONS,
            CREDIT_CARD_BUSINESS_SOURCE_OPTIONS,
            // UPI_OPTIONS,
            // UPI_MANDATE_OPTIONS,
            // UPI_BUSINESS_SOURCE,
            UPI_ACCOUNT_TYPES,
            NET_BANKING_OPTIONS,
            WALLET_OPTIONS,
            isEditMode,
        });

        if (request) {
            request.pgMidInfoId = formIdentifier;
            console.log("isedir",isEditMode,request);    
            if (isEditMode) {
                request.referenceId = formIdentifier;
                actions.updatePaymentGatewayCredentialStepRequest(
                    request,
                    sectionType,
                    values
                );
            } else {
                actions.createPaymentGatewayCredentialStepRequest(
                    request,
                    sectionType,
                    values
                );
            }
        }
    };

    useEffect(() => {
        actions.fetchPaymentModesRequest();
    }, [actions]);

    const handleSelectAllNetBanking = () => {
    setSelectAllNetBanking(!selectAllNetBanking);
    if (!selectAllNetBanking) {
        /* If Select All is  checked, select all the Net Banking options*/
        change('netbanking', NET_BANKING_OPTIONS.map(option => option.value));
    } else {
        /* If Select All is unchecked, deselect all the Net Banking options*/
        change('netbanking', []);
    }
};
useEffect(() => {
    const netbankingValues = formData?.values?.netbanking || [];
    const allSelected = NET_BANKING_OPTIONS.every(option =>
        netbankingValues.includes(option.value)
    );
    setSelectAllNetBanking(allSelected); // Set the Select All checkbox state accordigly
}, [formData?.values?.netbanking, NET_BANKING_OPTIONS]);

    useEffect(() => {
        if(isEditMode || isViewMode){
            actions.fetchPaymentGatewayCredentialDataRequest({
            pgMidReferenceId: parseInt(formIdentifier),
        });
    }
    }, [actions]);
    return (
        <form
            className="pg-onboarding-form card"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <h2 className="tab-title">Payment Mode Details</h2>
            <ul className="form-list">
                <li className="form-section">
                    <div className="form-field custom-field">
                        <p className="label">Debit Card</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="debitCard"
                            id="debit-card"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={DEBIT_CARD_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    <div className="form-field custom-field">
                        <p className="label">Debit Card Business Source</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="debitCardBusinessSource"
                            id="debitCardBusinessSource"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={DEBIT_CARD_BUSINESS_SOURCE_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    <div className="form-field custom-field">
                        <p className="label">Credit Card</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="creditCard"
                            id="creditCard"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={CREDIT_CARD_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    <div className="form-field custom-field">
                        <p className="label">Credit Card Business Source</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="creditCardBusinessSource"
                            id="creditCardBusinessSource"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={CREDIT_CARD_BUSINESS_SOURCE_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    {/* <div className="form-field custom-field">
                        <p className="label">UPI</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="upi"
                            id="upi"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={UPI_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    <div className="form-field custom-field">
                        <p className="label">UPI Mandate Mode</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="upiMandate"
                            id="upiMandate"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={UPI_MANDATE_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div> */}
                    {/* <div className="form-field custom-field">
                        <p className="label">UPI Business Source</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="upiBusinessSource"
                            id="upiBusinessSource"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={UPI_BUSINESS_SOURCE}
                            isDisabled={isViewMode}
                        />
                    </div> */}
                    {formData &&
                        formData.values &&
                        formData.values.upi &&
                        formData.values.upi.length > 0 &&
                        formData.values.upiBusinessSource &&
                        formData.values.upiBusinessSource.length > 0 &&
                        formData.values.upiBusinessSource.map(
                            businessSource => (
                                <div className="form-field custom-field">
                                    <p className="label">
                                        {capitalizeStringWithUnderscores(
                                            businessSource
                                        )}{' '}
                                        Account Types
                                    </p>
                                    <Field
                                        name={`upiAccountTypes-${businessSource}`}
                                        id={`upi-account-types-${businessSource}`}
                                        component={FormElems.Checkbox}
                                        customClass="checkbox-group-item"
                                        labelField="accountTypesNameUI"
                                        valueField="accountTypesValue"
                                        options={
                                            UPI_ACCOUNT_TYPES[businessSource]
                                        }
                                        isDisabled={isViewMode}
                                    />
                                </div>
                            )
                        )}
                </li>
                <li className="form-section">
                    <div className="form-field custom-field">
                    <div style={{ display: 'flex' }}>
                            <p className="label">Net Banking</p>
                                <input
                                    style={{ height: '18px', width:'18px', marginTop:'8px'}}
                                    type="checkbox"
                                    checked={selectAllNetBanking}
                                    onChange={handleSelectAllNetBanking}
                                    disabled={isViewMode}
                                />
                                <label
                                    style={{ 
                                    marginTop:'11px',
                                    marginLeft:'4px'}}>
                                     Select All
                                </label>
                        </div>
                        <Field
                            customClass="checkbox-group-item"
                            name="netbanking"
                            id="netbanking"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={NET_BANKING_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                    <div className="form-field custom-field">
                        <p className="label">Wallets</p>
                        <Field
                            customClass="checkbox-group-item"
                            name="wallets"
                            id="wallets"
                            component={FormElems.Checkbox}
                            labelField="name"
                            valueField="value"
                            options={WALLET_OPTIONS}
                            isDisabled={isViewMode}
                        />
                    </div>
                </li>
            </ul>
            {errorMessage ? (
                <Alert customClass="error-msg">{errorMessage}</Alert>
            ) : null}
            <div className="form-section action">
                <FormElems.Button
                    id="back-btn"
                    buttonType="secondary"
                    text="Back"
                    type="button"
                    handleClick={onBack}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Next"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({
    auth,
    form,
    staticData,
    paymentGatewayCredentialsData,
    merchantData,
}) => ({
    auth,
    formData: form['pg-credentials-pay-mode-form'],
    staticData,
    paymentGatewayCredentialsData,
    merchantData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            change,
            createPaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialCreateFormData,
            fetchPaymentModesRequest,
            updatePaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialUpdateFormData,
            fetchPaymentGatewayCredentialDataRequest
        },
        dispatch
    ),
});

PGCredentialsModeForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    staticData: PropTypes.object,
    handleSubmit: PropTypes.func,
    formData: PropTypes.object,
    change: PropTypes.func,
    paymentGatewayCredentialsData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'pg-credentials-pay-mode-form',
        validate: pgCredentialsPayModeFormValidator,
        enableReinitialize: true,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(PGCredentialsModeForm);

